<template>
  <div class="about-us">
    <section class="banner-wrap">
      <div class="banner">
        <div class="text">
          <div class="title opacity-0 animate__animated" data-animate="animate__fadeInLeftBig">关于我们</div>
          <div class="sub-title opacity-0 animate__animated" data-animate="animate__fadeInRightBig">发心利他，创造共享</div>
        </div>
      </div>
    </section>

    <section class="introduce-zzt">
      <div class="content opacity-0 animate__animated" data-animate="animate__fadeInUp">
        <img src="https://images.zzt.com.cn/cdn_file/zst-official/bg_公司简介.png" width="230">
        <div class="text">
          <div class="title">公司简介</div>
          <div class="desc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中知数通是一家以科技企业价值发现为使命，专注于产业科技金融创新的AI应用公司。致力于为银行、投资机构及证券公司提供覆盖科技金融全链路的智能分析与决策参考。基于独家构建的 460万+ 科技企业成长基因库，打造了AIPulse平台，以深眸（企业画像）、瞰见（产业洞察）、点睛投研（投资决策）等智能体，赋能科技金融场景应用。</div>
        </div>
      </div>
    </section>

    <section class="found">
      <div class="text">
        <div class="title">让更多科技企业被看见</div>
        <div class="desc">
          我们相信，每一家拥有真技术、硬实力的科技企业，不论规模大小、不论发展阶段，都值得被精准识别、被合理定价、被公平赋能。<br/>中知数通以科技金融大数据能力消除信息壁垒，让更多"早小硬"科创企业被金融机构真正"看懂"与"看见"。<br/>"发心利他，创造共享"是我们始终坚持的价值核心。
        </div>
      </div>
      <div class="content">
        <div class="found-box">
          <div class="found-item" v-for="(item, index) in foundList" :key="index">
            <img :src="item.img" width="84">
            <div>{{ item.title }}</div>
            <div>{{ item.subTitle }}</div>
          </div>
        </div>
        <div class="found-text">
          <div>迈向ESG新征程</div>
          <div>未来，我们将以ESG理念为指引，让可持续发展融入每一步业务实践。<br/>当每一家科技企业都被看见，创新的火种就不会熄灭；当金融活水精准灌溉科技，产业的未来才会生生不息。</div>
        </div>
      </div>
    </section>

    <section class="team">
      <div class="text">
        <div class="title">坚实AI团队力量</div>
      </div>
      <div class="content">
        <div class="team-box">
          <div class="team-item" v-for="(item, index) in teamList" :key="index">
            <img :src="item.img" width="70">
            <div class="name">
              <span>{{ item.name }}</span>
              <span>{{ item.position }}</span>
            </div>
            <div class="desc-box">
              <span class="desc">{{ item.desc }}</span>
              <div class="tags" v-if="item.tags && item.tags.length > 0">
                <span v-for="(its, idx) in item.tags" :key="idx">{{ its }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="credential">
      <div class="text">
        <div class="title">发心利他，创造共享</div>
        <div class="sub-title">行业资质认证与专业能力背书</div>
      </div>
      <div class="content">
        <div class="credential-item" v-for="(its, index) in credentialList" :key="index">
          <img :src="its.img" width="316">
        </div>
      </div>
    </section>

    <section class="dynamic">
      <div class="text">
        <div class="title">公司动态</div>
        <div class="sub-title">行业资质认证与专业能力背书</div>
      </div>
      <div class="content">
        <el-carousel indicator-position="outside" style="width: 100%;" height="400px" arrow="always"
          class="custom-dynamic-swiper">
          <el-carousel-item v-for="item in partition(dynamicList, 3)" :key="item.title">
            <div class="dynamic-swiper">
              <div v-for="(its, idx) in item" :key="idx" class="dynamic-item hover_effect">
                <div class="img-box">
                  <img :src="its.banner" width="378">
                </div>
                <main>
                  <div class="card-title">{{ its.title }}</div>
                  <div class="detail">{{ its.detail }}</div>
                  <footer>
                    <span class="time">{{ its.time }}</span>
                    <span class="link" @click="toJump(its.link)">查看详情</span>
                  </footer>
                </main>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </section>
  </div>
</template>
<script>
import { useAnimate } from '@/hooks'

export default {
  name: 'AboutUsV2',
  data () {
    return {
      foundList: [
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/big_icon_服务企业.png',
          title: '100万+',
          subTitle: '服务企业'
        },
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/big_icon_企业获贷.png',
          title: '1000亿元+',
          subTitle: '助力企业获贷'
        },
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/big_icon_深眸用户.png',
          title: '2万+',
          subTitle: '深眸用户'
        }
      ],
      teamList: [
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_赵教授.png',
          name: '赵才荣',
          position: 'CTO',
          desc: '中知数通首席科学家，兼中知数通科技金融人工智能研究院院长，带领产研团队构建了公司高质量数据底座、科技金融全场景应用的智能体产品体系。同济大学计算机学院教授、博士生导师，大数据与人工智能系主任，上海市计算机视觉专委会主任，中国图像图形学会青工委秘书长，ACM中国上海分会副主席。'
        },
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/icon_技术团队.png',
          name: 'AI技术团队',
          position: '核心技术力量',
          desc: '覆盖大数据、人工智能、金融工程等多学科，核心成员来自清华、北大等知名高校及头部科技企业，持续探索大模型、智能体在科技金融场景的创新应用。',
          tags: ['多学科融合']
        }
      ],
      credentialList: [
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/credential_1.png'
        },
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/credential_2.png'
        },
        {
          img: 'https://images.zzt.com.cn/cdn_file/zst-official/credential_3.png'
        }
      ],
      dynamicList: [
        {
          banner: 'https://images.zzt.com.cn/cdn_file/2025-12-31/1230news.png',
          title: '年末冲刺，重磅发布',
          detail: '12月28日，在第十届中国制造强国论坛上，中知数通携手战略合作伙伴中制智库进行了两项重磅发布：“中小企业特色产业集群创新发展指数”与“瞰见系统-科技创新与产业创新融合平台”。',
          time: '2025-12-30',
          link: 'https://mp.weixin.qq.com/s/bzlNfT1roHEdO8wo4xInYw'
        },
        {
          banner: 'https://images.zzt.com.cn/cdn_file/2025-05-23/0517news.jpg',
          title: '锚定“最后一公里” 数智化赋能成效凸显 银行业积极擦亮服务科创“底色”',
          detail: '中知数通已与多家银行达成合作，旨在通过大数据和人工智能技术，动态监测科技企业成长性的优变劣变基因，为科技企业提供全面的科技实力评估和成长潜力分析。',
          time: '2025-5-17',
          link: 'https://article.xuexi.cn/articles/index.html?art_id=10286819100116449392&t=1747449936795&showmenu=false&study_style_id=feeds_opaque&source=share&share_to=wx_single&item_id=10286819100116449392&ref_read_id=e27dd878-8897-4f05-833a-a7760927ae4c_1747460721841'
        },
        {
          banner: 'https://images.zzt.com.cn/cdn_file/2024-12-16/1203news.png',
          title: '中知数通：以数为基 以用为擎 | 第十九届中小商业银行CEO论坛',
          detail: '1月21-22日，第十九届中小商业银行CEO论坛在广州举办。作为联合主办单位，中知数通CEO肖运龙分享科技金融前沿动态，深入探讨了科技金融的发展趋势，并提出了“以数为基，以用为擎”的战略理念，旨在让科技金融触手可及。',
          time: '2024-12-03',
          link: 'https://mp.weixin.qq.com/s/KflnbCz0fj2sBjD1eQCFzQ?token=409551773&lang=zh_CN'
        },
        {
          banner: 'https://images.zzt.com.cn/cdn_file/2024-12-16/1015news.png',
          title: '中知数通与华夏银行广州分行签署战略合作协议 助力科技金融高质量发展',
          detail: '10月11日下午，中知数通与华夏银行广州分行举行战略合作签约仪式。中知数通的"深眸“系统提供深入的企业科技信息，银行的客户经理提供了强有力的展业工具，帮助更好地理解和服务科技型企业。',
          time: '2024-10-15',
          link: 'https://mp.weixin.qq.com/s/xelASRrWveO7PGJrpEphEw?token=409551773&lang=zh_CN'
        },
        {
          banner: 'https://images.zzt.com.cn//officialWebsite/0620news.png',
          title: '服务中国大科创时代，让科技金融触手可及——“深眸系统”银行版重磅发布',
          detail: '由融至道咨询、山西银行、中知数通联合主办的第七届新银行发展策略大会在龙城太原成功举行。中知数通在大会上推出科技金融“百日扬帆”公益计划，并重磅发布了深眸系统-科技企业成长性与科技力评测系统（银行版）。',
          time: '2024-06-25',
          link: 'https://mp.weixin.qq.com/s?__biz=Mzg2NjgxNTE5NA==&mid=2247485006&idx=1&sn=5ad1e35f75e8504ed24bd83ce9cb7909&chksm=ce445bfbf933d2ed81364fcefbe7b4e2a7749b5e029c0ace8997bf54b0b1f9870ba05b62512b&token=2086822754&lang=zh_CN&from=industrynews&version=4.1.10.8002&platform=win&nwr_flag=1#wechat_redirect'
        },
        {
          banner: 'https://images.zzt.com.cn/gnW/2024/04/30/0427news.png',
          title: '2024中关村论坛《科创企业创新力评价标准》正式发布',
          detail: '4月27日，《科创企业创新力评价标准》正式发布，将助力企业科技创新，加快推动企业科技成果转化，推动企业提升综合竞争力，加快发展新质生产力。',
          time: '2024-04-27',
          link: 'https://mp.weixin.qq.com/s?__biz=Mzg2NjgxNTE5NA==&mid=2247484996&idx=1&sn=9754ef4379726ca9045590d918277627&chksm=ce445bf1f933d2e7fac0fb10bfd5f29599a12cbd32dacd507c6cf1601d24098c7277022b4d12&token=1537796208&lang=zh_CN#rd'
        },
        {
          banner: 'https://images.zzt.com.cn/ks/2023/06/19/rank3.png',
          title: '2023网络安全企业科技能力报告',
          detail: '中知智库与安全419作为主要支撑研究单位，联合中关村网络安全与信息化产业联盟发布《2023网络安全企业科技能力报告》，发现有效专利超八成为发明专利，且总估值超亿元；近五年新增公开专利数量连年上涨；专利聚焦于数字信息传输、电数字数据处理。',
          time: '2023-05-31',
          link: 'https://mp.weixin.qq.com/s?__biz=Mzg2NjgxNTE5NA==&mid=2247484907&idx=1&sn=5fd75c2823cda2704cc2a2ccc233dcce&chksm=ce44585ef933d148359e989f348724718af54c0e05a6d98864e2730e2d9b889967bd361f1bcb&vid=1688854700419086&deviceid=1e5ce778-1918-447a-b62b-7c9e9314f5a0&version=4.1.6.6018&platform=win#rd'
        },
        {
          banner: 'https://images.zzt.com.cn/ox/2022/12/26/car.png',
          title: '汽车芯片国产化不足，哪些企业将成为破局者？',
          detail: '汽车芯片逐渐成为最重要的零部件之一。在“国产替代”成为当前国际科技竞争的主旋律背景下，国内企业正在从汽车芯片的各个领域逐个击破。从长远来看，在汽车芯片技术研发、车规级认证和量产方面取得进展后，国内企业有机会实现全方面打破国外垄断的愿景。',
          time: '2022-12-08',
          link: 'https://mp.weixin.qq.com/s/hqva491jh13U5MVWh7q5nA'
        },
        {
          banner: 'https://images.zzt.com.cn/ox/2022/12/08/dynamic_1.png',
          title: '中国企业科技力量化评测联合课题组成立',
          detail: '中国技术市场协会、中国知识产权研究会、新华社《经济参考报》、知识产权出版社与中知数通（北京）信息技术……',
          time: '2022-11-28',
          link: 'https://mp.weixin.qq.com/s/MvT6Yy7sAwpuHwxp1m52wQ'
        },
        {
          banner: 'https://images.zzt.com.cn/ox/2022/11/03/rank22.png',
          title: '构筑我国能源安全的“主动脉”，这些特高压领域企业榜上有名！',
          detail: '中国作为世界第一能源消耗大国，守护能源安全任重道远。因为特高压技术的从无到有，从跟随到引领，我国一步一步的构筑起了纵横交错，横贯东西的能源输送“主动脉”。在全球能源安全异常重要的当下，更显弥足珍贵。',
          time: '2022-10-27',
          link: 'https://mp.weixin.qq.com/s?__biz=Mzg2NjgxNTE5NA==&mid=2247484424&idx=1&sn=239873fb03815cc4374332c1b32eb00b&chksm=ce4459bdf933d0ab0bfee00763d9ca2bc73cbaf61eb69145bde2fed817f64c1600935cbd9b78#rd'
        },
        {
          banner: 'https://images.zzt.com.cn/ks/2023/06/06/rank1.png',
          title: '新能源电池企业专利指数排行榜发布，产业格局仍有短板尚未突破！',
          detail: '新能源电池企业专利指数排行榜发布，比亚迪超过“宁王”，成“榜上一哥”，但产业格局仍有短板尚未突破！',
          time: '2022-09-22',
          link: 'https://mp.weixin.qq.com/s/Pl3TYfqqq-i0AUGp_flQ1w'
        },
        {
          banner: 'https://images.zzt.com.cn/ox/2022/12/07/dynamic2.png',
          title: '国内首个知识产权数字化流通生态平台建设启动',
          detail: '国家知识产权局直属单位和知识产权信息服务专业机构知识产权出版社有限责任公司与在线资产交易平台阿里资产达成数……',
          time: '2022-09-09',
          link: 'http://www.jjckb.cn/2022-09/09/c_1310661059.htm'
        },
        {
          banner: 'https://images.zzt.com.cn/ox/2022/12/07/dynamic3.png',
          title: '专利大数据应用系统“深眸”上线',
          detail: '由国家知识产权局知识产权出版社、中知数通（北京）信息技术有限公司联合打造的专利大数据应用系统“深眸”日前正式……',
          time: '2022-04-28',
          link: 'http://www.jjckb.cn/2022-04/28/c_1310577086.htm'
        }
      ]
    }
  },
  methods: {
    toJump (link) {
      window.open(link, '_blank')
    },
    partition (arr, chunkSize) {
      const result = []
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize)
        result.push(chunk)
      }
      return result
    }
  },
  mounted () {
    const { animate } = useAnimate()
    animate()
  }
}
</script>
<style lang="scss" scoped>
.about-us {
  width: 100%;
  min-width: $container-width;
}

section {
  .content {
    width: $container-width;
    margin: 0 auto;

    .img-container {
      display: flex;
      justify-content: space-between;

      img {
        margin-left: Translate(20px);
      }
    }
  }

  .title {
    @include Text(36px, 500, 50px, #111111, 'PingFangSC-Medium');
  }

  .sub-title {
    margin-top: Translate(4px);
    @include Text(16px, 400, 30px, #666666, 'PingFangSC-Regular');
  }
}

.banner {
  position: relative;
  height: Translate(320px);
  background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_关于我们.png") no-repeat;
  background-position: center center;
  background-size: cover;
  margin: 0 auto;

  .text {
    width: $container-width;
    margin: 0 auto;
    text-align: center;
    padding-top: Translate(118px);

    .sub-title {
      color: #333333;
    }
  }
}

.introduce-zzt {
  box-sizing: border-box;
  background: #FFFFFF;
  padding-top: Translate(74px);
  padding-bottom: Translate(83px);

  .content {
    display: flex;
    gap: Translate(38px);

    .text {
      flex: 1;
      text-align: left;
      margin-top: Translate(22px);

      .desc {
        width: Translate(932px);
        letter-spacing: 1px;
        @include Text(16px, 400, 30px, #333333, 'PingFangSC-Regular');
      }
    }
  }
}

.credential {
  background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_发心利他.png") no-repeat;
  background-position: center center;
  background-size: cover;
  padding-top: Translate(98px);
  padding-bottom: Translate(104px);

  .content {
    display: flex;
    justify-content: center;
    gap: Translate(56px);
    margin-top: Translate(26px);
  }
}

.found {
  background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_更多企业被看见.png") no-repeat;
  background-position: center center;
  background-size: cover;
  padding-top: Translate(64px);
  padding-bottom: Translate(64px);

  .text {
    .title {
      color: #fff;
    }

    .desc {
      margin-top: Translate(6px);
      opacity: 0.8;
      @include Text(14px, 400, 24px, #fff, 'PingFangSC-Regular');
    }
  }

  .found-box {
    display: flex;
    justify-content: center;
    gap: Translate(24px);
    margin-top: Translate(44px);

    .found-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: Translate(384px);
      height: Translate(240px);
      background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_found.png") no-repeat;
      background-position: center center;
      background-size: 100% 100%;
      border-radius: Translate(14px);
      transition: all 0.3s ease-in;

      &:hover {
        transform: translateY(Translate(-2px));
        box-shadow: 0 4px 20px 0 rgba(255, 255, 255, 0.6);
      }

      img {
        margin-bottom: Translate(21px);
      }

      div + div {
        margin-top: Translate(6px);
      }

      div:nth-child(2) {
        @include Text(28px, 700, 30px, #0058FF, 'DINAlternate-Bold');
      }

      div:nth-child(3) {
        @include Text(18px, 500, 34px, #111111, 'PingFangSC-Medium');
      }
    }
  }

  .found-text {
    margin-top: Translate(38px);

    div:first-child {
      margin-bottom: Translate(3px);
      @include Text(20px, 500, 34px, #fff, 'PingFangSC-Medium');
    }

    div:nth-child(2) {
      opacity: 0.8;
      @include Text(14px, 400, 24px, #fff, 'PingFangSC-Regular');
    }
  }
}

.team {
  background: url("https://images.zzt.com.cn/cdn_file/zst-official/bg_团队力量.png") no-repeat;
  background-position: center center;
  background-size: cover;
  padding-top: Translate(88px);
  padding-bottom: Translate(98px);

  .text {
    .title {
      @include GradientText();
    }
  }

  .team-box {
    display: flex;
    justify-content: center;
    gap: Translate(34px);
    margin-top: Translate(44px);

    .team-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: Translate(450px);
      background-color: #FFFFFF;
      padding: Translate(47px) Translate(20px) Translate(20px);
      border-radius: Translate(14px);
      box-sizing: border-box;
      transition: all 0.3s ease-in;

      &:hover {
        transform: translateY(Translate(-2px));
        box-shadow: 0 4px 8px 0 rgba(166, 166, 166, 0.1);
      }

      .name {
        display: flex;
        gap: Translate(12px);
        margin-top: Translate(14px);
        @include Text(18px, 500, 34px, #1D2745, 'PingFangSC-Medium');

        span:last-child {
          color: #0058FF;
        }
      }

      .desc-box {
        margin-top: Translate(25px);
        background-color: #FAFAFA;
        padding: Translate(13px) Translate(18px);
        text-align: left;
        border-radius: Translate(8px);

        .desc {
          @include Text(14px, 400, 24px, #333333, 'PingFangSC-Regular');
        }

        .tags {
          display: flex;
          margin-top: Translate(37px);
          margin-bottom: Translate(7px);

          span {
            @include Tag();
          }
        }
      }
    }
  }
}

.dynamic {
  background-color: #F5F6F9;
  padding-top: Translate(78px);
  padding-bottom: Translate(57px);

  .content {
    width: Translate(1328px);
    display: flex;
    justify-content: center;

    .dynamic-swiper {
      width: $container-width;
      // width: 100%;
      display: flex;
      overflow: hidden;

      .dynamic-item {
        width: Translate(378px);
        height: Translate(396px);
        margin-right: Translate(33px);
        border-radius: Translate(10px);
        overflow: hidden;

        .img-box {
          width: 100%;
          height: Translate(210px);
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
          }
        }

        main {
          background-color: #fff;
          padding: Translate(26px) Translate(20px);
          text-align: left;

          .card-title {
            width: Translate(338px);
            margin-bottom: Translate(8px);
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            @include Text(16px, 500, 24px, #111111, 'PingFangSC-Medium');
          }

          .detail {
            height: Translate(48px);
            margin-bottom: Translate(34px);
            text-overflow: ellipsis;
            white-space: wrap;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            @include Text(14px, 400, 24px, #666666, 'PingFangSC-Regular');
          }

          footer {
            display: flex;
            justify-content: space-between;
            @include Text(14px, 400, 20px, #666666, 'PingFangSC-Regular');

            .link {
              color: #0058FF;

              &:hover {
                cursor: pointer;
                opacity: 0.8;
              }
            }
          }
        }
      }
    }
  }
}

::v-deep .custom-dynamic-swiper {
  padding-top: Translate(30px);

  .el-carousel__container {
    .el-carousel__item {
      display: flex;
      justify-content: center;
    }

    .el-carousel__arrow--left {
      left: 0;
    }

    .el-carousel__arrow--right {
      right: 0;
    }
  }

  .el-carousel__indicators {
    padding-top: Translate(6px);
    .is-active {
      .el-carousel__button {
        background: #0058FF;
      }
    }
  }

  .el-carousel__button {
    width: 8px;
    height: 8px;
    background: #BBBBBB;
    border-radius: 50%;
  }

  .is-active .el-carousel__button {
    width: 8px;
    height: 8px;
    background: #0058FF;
    border-radius: 50%;
  }
}
</style>
